import { useTheme } from '@mui/material';
import { lighten } from '@mui/material/styles';
import { style } from '@mui/system';
import { useMemo } from 'react';

const colorFromTheme = style({
  prop: 'color',
  themeKey: 'palette',
});

export default function useThemeColor(color?: string): string | undefined {
  const theme = useTheme();
  const c = useMemo(() => {
    if (!color) {
      return undefined;
    }

    const [main, secondary = 'main'] = color.split('.');
    const themeColor = colorFromTheme({ color: main, theme });
    if (secondary === 'extraLight') {
      return lighten(themeColor.color.main, 0.9);
    }

    if (!themeColor?.color[secondary]) {
      return undefined;
    }
    return themeColor.color[secondary];
  }, [color]);

  return c;
}
